module.exports = __webpack_public_path__ + "/img/8396aad51669c17171de30537bb34920.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/icons/cross-ico.png
 ** module id = 18
 ** module chunks = 0 4 5
 **/